module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-content m-b-xl"
  }, [_vm._v("\n" + _vm._s( /** case title wrapper */ ) + "\n  "), _c('div', {
    staticClass: "clearfix m-t-40 border-top"
  }, [_vm._v("\n    " + _vm._s( /** images */ ) + "\n    "), _c('div', {
    staticClass: "cas-img-wrp m-r-lg"
  }, [_c('div', {
    staticClass: "cas-main-img img-c-div",
    style: ({
      backgroundImage: "url(" + _vm.images[_vm.activeImg] + ")"
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "cas-s-img-wrp clearfix"
  }, _vm._l((_vm.images), function(img, index) {
    return _c('div', {
      style: ({
        backgroundImage: 'url(' + img + ')'
      }),
      on: {
        "click": function($event) {
          _vm.activeImg = index
        }
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "cas-img-wrp-next"
  }, [_c('h3', {
    staticClass: "cas-title-ct"
  }, [_vm._v(_vm._s(_vm.cas.title))]), _vm._v(" "), _c('div', {
    class: {
      'labels': _vm.labels.length < 1
    }
  }, [_c('div', {
    staticClass: "cas-tag-wrp"
  }, _vm._l((_vm.labels), function(label) {
    return _c('span', [_vm._v(_vm._s(label))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "cas-price-wrp"
  }, [_c('div', {
    staticClass: "cas-info clamp"
  }, [_vm._v(_vm._s(_vm.cas.briefInfo ? _vm.cas.briefInfo : _vm.cas.description))]), _vm._v(" "), _c('div', {
    class: {
      'promotion': _vm.cas.isPromotion !== 2
    }
  }, [(_vm.cas.isPromotion === 2) ? _c('div', {
    staticClass: "coupon m-t",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/promo_icon.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.cas.promotionInfo) + "\n            ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "cas-pay-wrap"
  }, [_c('div', [(!_vm.isRealProduct) ? _c('button', {
    staticClass: "c-b c-b-book",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.bookNow
    }
  }, [_vm._v("现在预定")]) : _vm._e(), _vm._v(" "), (_vm.isRealProduct) ? _c('button', {
    staticClass: "c-b c-b-book",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goBuy(_vm.cas.buyLink)
      }
    }
  }, [_vm._v("去购买")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "c-b telInfo m-l-50",
    attrs: {
      "type": "button",
      "id": "telInfo"
    }
  }, [_vm._v(_vm._s(_vm.telInfo))])]), _vm._v(" "), (_vm.cas.isFavored) ? _c('div', {
    staticClass: "fav-area text-center",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.unFavorCaseInfo(_vm.cas)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-heart heart-pink"
  }), _vm._v(" "), _c('span', {
    staticClass: "gray-1 text-small"
  }, [_vm._v("收藏（" + _vm._s(_vm.cas.favorNum) + "）")])]) : _vm._e(), _vm._v(" "), (!_vm.cas.isFavored) ? _c('div', {
    staticClass: "fav-area text-center",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.favorCaseInfo(_vm.cas)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "color": "#a9a9a9"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "gray-1 text-small"
  }, [_vm._v("收藏（" + _vm._s(_vm.cas.favorNum) + "人气）")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-xl clearfix"
  }, [_vm._v("\n    " + _vm._s( /** 左边商家、商家相关案例、留言 */ ) + "\n    "), _c('div', {
    staticClass: "cas-shop-wrp"
  }, [_c('div', {
    staticClass: "cas-shop-header"
  }, [_c('div', {
    staticClass: "cas-shop-img img-c-div",
    style: ({
      backgroundImage: 'url(' + _vm.shop.coverImgUrl + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-md m-b-lg"
  }, [_vm._v("\n          " + _vm._s(_vm.shop.name) + "\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "c-b c-b-to-shop link-text",
    on: {
      "click": function($event) {
        return _vm.goToShop(_vm.shop.id)
      }
    }
  }, [_vm._v("进入店铺")])]), _vm._v(" "), _c('div', {
    staticClass: "cas-shop-infor b-gray-1 m-t-md"
  }, [_vm._v("\n        商家资讯\n      ")]), _vm._v(" "), _vm._l((_vm.poster_list), function(p) {
    return _c('div', {
      staticClass: "related-cas clearfix",
      on: {
        "click": function($event) {
          return _vm.goPosterDetail(p.uuid)
        }
      }
    }, [_c('div', {
      staticClass: "related-cas-img-div mg-style",
      style: ({
        backgroundImage: 'url(' + p.cover + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "related-cas-content"
    }, [_c('div', {
      staticClass: "related-cas-header clamp-title"
    }, [_vm._v(_vm._s(p.title.substring(0, 22)))]), _vm._v(" "), _c('div', {
      staticClass: "related-cas-desc"
    }, [(p.type !== 4 && p.content[0]) ? _c('span', {
      staticClass: "clamp"
    }, [_vm._v(_vm._s(p.content[0].text.substring(0, 24)))]) : _vm._e(), _vm._v(" "), (p.type === 4) ? _c('span', {
      staticClass: "clamp"
    }, [_vm._v(_vm._s(p.content.text.substring(0, 24)))]) : _vm._e()])])])
  }), _vm._v(" "), _c('form', {
    staticClass: "m-t-md b-gray-1",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveComment.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "cas-shop-infor"
  }, [_vm._v("提交留言")]), _vm._v(" "), _c('div', {
    staticClass: "p-a-md text-center"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-input",
    attrs: {
      "placeholder": "请填写您的留言信息"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    class: {
      'c-b c-b-to-shop m-t-md': true,
      'disabled': !_vm.comment
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("提交")])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "cas-details b-gray-1"
  }, [_vm._v("\n      " + _vm._s( /** 右边案件详情 */ ) + "\n      "), _c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky",
      value: ({
        zIndex: 12,
        stickyTop: -4
      }),
      expression: "{ zIndex: 12, stickyTop: -4 }"
    }]
  }, [_c('div', {
    staticClass: "cas-details-tab"
  }, [_c('span', {
    class: {
      'active': _vm.activeDetailTag === 0
    },
    on: {
      "click": function($event) {
        return _vm.scrollTo('cas-detail-desc', 0)
      }
    }
  }, [_vm._v("案例概述")]), _c('span', {
    class: {
      'active': _vm.activeDetailTag === 2
    },
    on: {
      "click": function($event) {
        return _vm.scrollTo('cas-detail-picTxt', 2)
      }
    }
  }, [_vm._v("图文详情")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cas.priceScheme),
      expression: "cas.priceScheme"
    }],
    class: {
      'active': _vm.activeDetailTag === 1
    },
    on: {
      "click": function($event) {
        return _vm.scrollTo('cas-detail-priceScheme', 1)
      }
    }
  }, [_vm._v("费用解析")])])]), _vm._v(" "), _c('div', {
    staticClass: "cas-details-content-wrp",
    attrs: {
      "id": "cas-detail-desc"
    }
  }, [(_vm.cas.description) ? _c('div', {
    staticClass: "cas-details-header"
  }, [_c('span', [_vm._v("婚礼概述")])]) : _vm._e(), _vm._v(" "), (_vm.cas.description) ? _c('div', {
    staticClass: "cas-details-content text-prewarp"
  }, [_c('pre', [_vm._v(_vm._s(_vm.cas.description))])]) : _vm._e(), _vm._v(" "), (_vm.cas.themeDesc) ? _c('div', {
    staticClass: "cas-details-header"
  }, [_c('span', [_vm._v("主题诠释")])]) : _vm._e(), _vm._v(" "), (_vm.cas.themeDesc) ? _c('div', {
    staticClass: "cas-details-content m-t-20"
  }, [_c('pre', [_vm._v(_vm._s(_vm.cas.themeDesc))])]) : _vm._e(), _vm._v(" "), (_vm.cas.designDesc) ? _c('div', {
    staticClass: "cas-details-header"
  }, [_c('span', [_vm._v("设计说明")])]) : _vm._e(), _vm._v(" "), (_vm.cas.designDesc) ? _c('div', {
    staticClass: "cas-details-content m-t-20"
  }, [_c('pre', [_vm._v(_vm._s(_vm.cas.designDesc))])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.picTxtJson), function(txt, index) {
    return [(txt.type === 0) ? [_c('div', {
      staticClass: "cas-details-header"
    }, [_c('span', [_vm._v(_vm._s(txt.txt))])])] : _vm._e(), _vm._v(" "), (txt.type === 1) ? [_c('div', {
      staticClass: "cas-details-content m-t-20"
    }, [_c('pre', [_vm._v(_vm._s(txt.txt))])])] : _vm._e(), _vm._v(" "), (txt.type === 2) ? [_c('img', {
      staticClass: "m-t-20",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": txt.pic_url
      }
    })] : _vm._e(), _vm._v(" "), (txt.type === 3) ? [_vm._v("\n            " + _vm._s( /** 视频 */ ) + "\n            "), _c('p', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('iframe', {
      staticClass: "video_iframe",
      staticStyle: {
        "z-index": "1"
      },
      attrs: {
        "src": _vm.getTecentUrl(txt.video_url),
        "allowfullscreen": "",
        "frameborder": "0",
        "height": "375",
        "width": "100%"
      }
    })])] : _vm._e()]
  }), _vm._v(" "), (_vm.cas.executeDesc) ? _c('div', {
    staticClass: "cas-details-header"
  }, [_c('span', [_vm._v("执行心得")])]) : _vm._e(), _vm._v(" "), (_vm.cas.executeDesc) ? _c('div', {
    staticClass: "cas-details-content m-t-20"
  }, [_c('pre', [_vm._v(_vm._s(_vm.cas.executeDesc))])]) : _vm._e(), _vm._v(" "), (_vm.cas.priceScheme) ? _c('div', {
    staticClass: "cas-details-header",
    attrs: {
      "id": "cas-detail-priceScheme"
    }
  }, [_c('span', [_vm._v("价格参考")])]) : _vm._e(), _vm._v(" "), (_vm.cas.priceScheme) ? _c('div', {
    staticClass: "cas-details-content"
  }, [_c('pre', [_vm._v(_vm._s(_vm.cas.priceScheme))])]) : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cas-details-header",
    attrs: {
      "id": "cas-detail-picTxt"
    }
  }, [_c('span', [_vm._v("案例展示")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dceb21c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CaseDetail.vue
// module id = 605
// module chunks = 1